import { useState } from 'react';
import { useNotifications } from '../notifications/NotificationProvider';
import { ClockIcon } from '@heroicons/react/24/outline';
import TaskListItem from './TaskListItem';

const AutoplannerTaskList = ({ tasks, onEditTask, onDeleteTask }) => {
  const [deletingTasks, setDeletingTasks] = useState(new Set());
  const { showConfirm } = useNotifications();

  const handleDeleteTask = async (taskId) => {
    const confirmed = await showConfirm(
      'Are you sure you want to delete this task? This action cannot be undone.',
      'Delete Task'
    );

    if (!confirmed) {
      return;
    }

    setDeletingTasks((prev) => new Set([...prev, taskId]));

    try {
      await onDeleteTask(taskId);
    } catch (error) {
      console.error('Error deleting task:', error);
    } finally {
      setDeletingTasks((prev) => {
        const newSet = new Set(prev);
        newSet.delete(taskId);
        return newSet;
      });
    }
  };

  if (tasks.length === 0) {
    return (
      <div className="rounded-lg bg-white p-4 shadow sm:p-6">
        <div className="text-center">
          <ClockIcon className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">No autoplanner tasks</h3>
          <p className="mt-1 text-sm text-gray-500">
            Get started by creating your first autoplanner task.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg bg-white shadow">
      <div className="border-b border-gray-200 px-4 py-3 sm:px-6 sm:py-4">
        <h3 className="text-lg font-medium text-gray-900">Autoplanner Tasks</h3>
      </div>
      <div className="divide-y divide-gray-200">
        {tasks.map((task) => (
          <TaskListItem
            key={task.id}
            task={task}
            onEditTask={onEditTask}
            onDeleteTask={handleDeleteTask}
            isDeleting={deletingTasks.has(task.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default AutoplannerTaskList;
